import useForm from 'js/hooks/useForm';
import FormRow from './FormRow'
import { useEffect } from 'react';

const repay = [
    { "value": "", "label": "Select" },
    { "value": "Partially", "label": "Partially" },
    { "value": "Repayable", "label": "Repayable" },
    { "value": "Non Repayable", "label": "Non Repayable" },
    { "value": "In Service", "label": "In Service" }
];

const dis_schedule = [
    { "value": "", "label": "Select" },
    { "value": "monthly", "label": "Monthly" },
    { "value": "quarterly", "label": "Quarterly" },
    { "value": "half-yearly", "label": "Half-Yearly" },
    { "value": "yearly", "label": "Yearly" },
    { "value": "one shot", "label": "One Shot" }
];

const security = [
    { "value": "", "label": "Select" },
    { "value": "Property", "label": "Property" },
    { "value": "Gold", "label": "Gold" },
    { "value": "Unsecured", "label": "Unsecured" },
    { "value": "Vehicle", "label": "Vehicle" },
    { "value": "Others", "label": "Others" }
];




const schema = [
    {
        label: "Has Guarantor?",
        name: "has_guarantor",
        type: "select",
        options: [
            { value: "No", label: "No" },
            { value: "Yes", label: "Yes" }
        ]
    },
    {
        "name": "guarantor_name",
        "label": "Guarantor name:",
        error: { required: true },
        validator: ({ has_guarantor }) => has_guarantor == "Yes"
    },
    {
        "name": "guarantor_phone",
        "label": "Guarantor phone number:",
        error: { required: true },
        validator: ({ has_guarantor }) => has_guarantor == "Yes"

    },
    {
        "name": "guarantor_email",
        "label": "Guarantor email id:",
        error: { required: true },
        validator: ({ has_guarantor }) => has_guarantor == "Yes"
    },
    {
        label: "Requested Grant Amount (₹)",
        name: "request_amt",
        required: true,
        error: { required: true }
    },
    {
        name: "referred_by",
        label: "Referred By:"

    },
    {
        name: "grant_type",
        label: "Grant Repayment",
        type: "select",
        options: repay
    },
    {
        name: "disbursement_schedule",
        label: "Disbursement Schedule:",
        type: "select",
        options: dis_schedule
    },
    {
        name: "collateral",
        label: "Collaterals or Securities to be provided against the grant:",
        type: "select",
        options: security
    },
]

const initialValue = { has_guarantor: "No" }
export default function Step3({ onChange, payload }) {

    const { data, isError, validFields, inputProps, setTouched } = useForm({ schema, payload, initialValue })

    const onClick = () => {
        if (isError()) {
            setTouched(true)
            return
        }
        onChange(data)
    }

    useEffect(() => {
        const btn = document.getElementById("submit")
        btn.addEventListener("click", onClick)

        return () => {
            btn.removeEventListener("click", onClick)
        }
    }, [data])

    return (
        <div>
            {validFields.map(d => <FormRow key={d.name} {...inputProps(d)} />)}
        </div>
    )
}
